import countryList from 'react-select-country-list'

export function CountryByCode(code) {
    let country = countryList().getLabel(code);
    if (country === "") {
        country = "-";
    }
    return country;
}